export enum LiquidationStatus {
  IN_PROGRESS = "IN_PROGRESS",
  SUBMITTED = "SUBMITTED",
  TO_FIX = "TO_FIX",
  CLOSE = "CLOSE"
}
